import { PARK_OUT_ERROR,PARK_IN_SUCCESS,EDIT_PARK_IN } from './actionTypes';

const initialState = {
    error: "",
    success : ""
}

const ParkingTransaction = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_PARK_IN:
            state = { ...state }
            break;
        case PARK_IN_SUCCESS:
            state = { ...state, success: action.payload }
            break;
        case PARK_OUT_ERROR:
            state = { ...state, error: action.payload };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default ParkingTransaction;